<div class="header-bar flex">
  <div class="flex-grow-1">
    <h1>Job Deployment - {{ jobInfo?.jobNumber }}</h1>
  </div>
  <div class="pt-2">
    <button
      *ngIf="organisationTypeId == 1 && (telephonyService.IdentifiedCallLoggable$ | async)"
      (click)="logCall()"
      label="Log Call"
      pButton
    ></button>
    <button
      pButton
      label="Direct To Suppliers"
      (click)="directToSupplier()"
      *ngIf="!grabDisabled"
    ></button>
    <!--    <button pButton label="Log Contact" (click)="logContact()"></button>-->
    <app-queue-auto-direct-button
      [jobIds]="[jobId]"
      buttonClass="ui-button-secondary"
    ></app-queue-auto-direct-button>
    <button pButton label="Job Details" (click)="jobDetails()"></button>
  </div>
</div>

<div *ngIf="grabDisabled" class="warning-container">
  <div class="flex grid-gap-10">
    <div class="flex-shrink-1 warning-icon">
      <i class="fa fa-warning" style="color: #f97316"></i>
    </div>
    <div class="flex-grow-1">
      <div class="warning-title">Direct To Suppliers Currently Unavailable</div>
      <div class="warning-text">
        Please note that you are currently unable to use the
        <strong>Direct To Suppliers</strong> function for this Job as the Job is either
        <strong>In Held</strong> or <strong>Grab</strong> has been disabled.
      </div>
    </div>
  </div>
</div>

<div *ngIf="sendingAlert" class="send-alert">
  <i class="fa fa-2x fa-spin fa-spinner"></i>
  <span style="margin-left: 15px; vertical-align: super">Sending alerts...</span>
</div>
<div class="job-deployment">
  <div class="content-container" style="position: relative">
    <div class="card card-w-title" *ngIf="organisationTypeId == 0">Load user data...</div>
    <div class="card card-w-title" *ngIf="jobInfo == null && organisationTypeId != 0">
      Load job info...
    </div>
    <div class="card card-w-title" *ngIf="jobInfo != null && isAccessDenied">Access Denied</div>
    <div class="" *ngIf="jobInfo != null && !isAccessDenied">
      <div class="ui-g" *ngIf="jobSummary">
        <div *ngIf="jobSummary" class="ui-g-12">
          <span style="float: left">{{ jobSummary }}</span>
        </div>
      </div>

      <div class="ui-g">
        <div class="ui-g-6 ui-sm-12">
          <div class="chloe-design-style">
            <p-panel styleClass="chloe-design-style no-padding-panel" header="Activity">
              <p-tabView class="no-widget-border no-padding-tab">
                <p-tabPanel header="Watching">
                  <div *ngFor="let item of watchingInterest" class="supplier-card-item">
                    <supplier-card
                      [data]="item"
                      (driverPlanClick)="driverPlanClick($event)"
                    ></supplier-card>
                  </div>

                  <!-- DATATABLE DEPRECATED ---
                                  <p-dataTabl [value]="jobInterest"
                                               styleClass="no-header"
                                               scrollable="true">
                                    <p-column header="" rowHover="false">
                                      <ng-template let-item="rowData" pTemplate="body">
                                        <supplier-card [data]="item" (driverPlanClick)="driverPlanClick($event)"></supplier-card>
                                      </ng-template>
                                    </p-column>

                                  </p-dataTable>
                                  -->
                </p-tabPanel>
                <p-tabPanel header="Hidden">
                  <div *ngFor="let item of hiddenInterest" class="supplier-card-item">
                    <supplier-card
                      [data]="item"
                      (driverPlanClick)="driverPlanClick($event)"
                    ></supplier-card>
                  </div>
                </p-tabPanel>
                <p-tabPanel header="Not Interacted">
                  <div *ngFor="let item of notInteractedInterest" class="supplier-card-item">
                    <supplier-card
                      [data]="item"
                      (driverPlanClick)="driverPlanClick($event)"
                    ></supplier-card>
                  </div>
                </p-tabPanel>
                <p-tabPanel header="History" class="p-2">
                  <timeline
                    [items]="jobHistory"
                    [iconMapping]="iconMap"
                    emptyMessage="No deployment history to display"
                  ></timeline>
                </p-tabPanel>
              </p-tabView>
            </p-panel>
          </div>
        </div>

        <!--Job Details-->
        <div class="ui-g-6 ui-sm-12">
          <job-deployment-details [jobInfo]="jobInfo"></job-deployment-details>
        </div>
      </div>
    </div>
  </div>
</div>

<!--DIALOGS-->

<p-dialog
  header="Log Contact"
  [(visible)]="showLogContactDialog"
  [modal]="true"
  [responsive]="true"
  [style]="{ 'max-width': '450px' }"
>
  <form #logContactForm="ngForm">
    <div class="ui-g ui-grid-responsive ui-fluid">
      <div class="ui-g-12">
        <div class="ui-g-4">Supplier</div>
        <div class="ui-g-8">
          <p-dropdown
            *ngIf="!contact.isFollowUp"
            name="supplierOptions"
            [options]="supplierOptions"
            placeholder="Select supplier"
            autoWidth="false"
            required
            [style]="{ width: '100%' }"
            [(ngModel)]="contact.supplierId"
            filter="true"
          ></p-dropdown>

          <span *ngIf="contact.isFollowUp" style="font-weight: bold">{{
            contact.supplierName
          }}</span>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4">Method</div>
        <div class="ui-g-8">
          <p-dropdown
            name="methodOptions"
            [options]="methodOptions"
            placeholder="Select status"
            autoWidth="false"
            required
            [style]="{ width: '100%' }"
            [(ngModel)]="contact.contactMethodId"
          ></p-dropdown>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4">Outcome</div>
        <div class="ui-g-8">
          <p-dropdown
            name="outcomeOptions"
            [options]="outcomeOptions"
            placeholder="Select outcome"
            autoWidth="false"
            required
            [style]="{ width: '100%' }"
            [(ngModel)]="contact.contactOutcomeId"
          ></p-dropdown>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4">Notes</div>
        <div class="ui-g-8">
          <textarea
            rows="4"
            name="notes"
            autoWidth="false"
            pInputTextarea
            required
            [style]="{ width: '100%' }"
            [(ngModel)]="contact.notes"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-g-12" style="float: right; margin-bottom: 10px">
      <button
        type="button"
        class="green-btn"
        pButton
        icon="fa ui-icon-check"
        (click)="logContactSave(contact)"
        [disabled]="logContactForm.invalid"
        label="Save"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Close"
        (click)="showLogContactDialog = false"
      ></button>
    </div>
  </form>
</p-dialog>

<allocate-job-dialog
  *ngIf="supplier && jobInfo"
  [(visible)]="showAllocateJobDialog"
  [supplierId]="supplier.id"
  [job]="jobInfo"
  (jobAllocated)="onAllocateJobSaved()"
  (close)="showAllocateJobDialog = false"
  (supplierPlanClick)="showDriverPlanDialog = true"
  referrPage="jobDeployment"
>
</allocate-job-dialog>

<!-- show driver plan -->
<p-dialog
  [(visible)]="showDriverPlanDialog"
  [modal]="true"
  [responsive]="true"
  [style]="{ 'max-width': '1200px' }"
>
  <p-header>
    <div class="ui-g-12">
      <div class="ui-grid-col-9">
        <h3 *ngIf="supplier" style="margin: 0px">Driver plan: {{ supplier.name }}</h3>
      </div>
      <div class="ui-grid-col-3" style="text-align: right">
        <h4 *ngIf="jobInfo" style="margin: 0px">
          {{ jobInfo.scheduledDate | datex : 'ddd DD MMM HH:mm' }}
        </h4>
      </div>
    </div>
  </p-header>

  <driver-plan *ngIf="jobInfo" #driverPlan [tasks]="jobInfo.tasks"></driver-plan>

  <div class="ui-grid-row">
    <button
      class="btn-to-right"
      type="button"
      pButton
      icon="fa ui-icon-close"
      label="Close"
      (click)="showDriverPlanDialog = false"
    ></button>
  </div>
</p-dialog>

<p-dialog
  #directToSupplierDialog
  [(visible)]="showDirectToSupplierDialog"
  [modal]="true"
  (visibleChange)="onDirectToSupplierHide()"
>
  <p-header *ngIf="jobInfo">
    <span class="job-number-text" (click)="jobDetails(true)">{{ jobInfo.jobNumber }}</span>
    <span class="direct-to-supplier-text">Direct to Supplier:</span>
    <span class="date-text">{{ jobInfo.scheduledDate | datex : 'ddd Do MMM YYYY' }}</span>
  </p-header>

  <div class="dialog-grid-container style2023">
    <!-- LEFT SIDE -->
    <div style="width: 60%; height: 100%; display: flex; flex-direction: column">
      <div style="flex-shrink: 1; display: flex; width: 100%; grid-gap: 5px; padding-bottom: 5px">
        <div class="grid-item-radius" style="align-content: space-evenly">
          <div class="input-group">
            <div class="input-group-prepend" style="height: 24px; line-height: 24px">
              Radius (mi)
            </div>
            <div
              class="input-group-item text-center"
              style="height: 24px; line-height: 24px; width: 70px; text-align: center"
            >
              <input
                type="number"
                maxlength="3"
                pInputText
                (keydown)="inputHelper.allowNumberInputKey($event, false)"
                (keyup)="inputHelper.fixDigits($event.target)"
                [(ngModel)]="searchRadius"
                (ngModelChange)="onRadiusChange({ value: searchRadius })"
              />
              <!--              {{ searchRadius }}-->
            </div>
          </div>
        </div>
        <div class="grid-item-minus" style="align-content: space-evenly">
          <button
            type="button"
            class="ui-secondary-button button-style"
            [style]="{ height: '24px' }"
            (click)="onAlterRadius(-5)"
          >
            <i class="fa fa-minus" style="vertical-align: super"></i>
          </button>
        </div>
        <div
          class="grid-item-slider"
          style="width: 200px; padding-top: 12px; padding-left: 5px; padding-right: 5px"
        >
          <p-slider
            [min]="minRadius"
            [max]="maxRadius"
            [step]="5"
            (onSlideEnd)="onRadiusChange($event)"
            [(ngModel)]="searchRadius"
          ></p-slider>
        </div>
        <div class="grid-item-plus" style="align-content: space-evenly">
          <button
            type="button"
            class="ui-secondary-button button-style"
            (click)="onAlterRadius(5)"
            [style]="{ height: '24px' }"
            data-test-id="increase-radius-btn"
          >
            <i class="fa fa-plus" style="vertical-align: super"></i>
          </button>
        </div>
        <div class="grid-item-custom flex-grow-1">
          <div class="input-group">
            <div class="input-group-item">
              <p-multiSelect
                name="location-radii"
                [options]="locationsData"
                [(ngModel)]="customRadiusSelections"
                defaultLabel="Locations"
                class="hide-multiselect-filter filter-dropdown input-group-filter"
                (onChange)="onLocationsChange($event)"
                pTooltip="Select Location Radii"
              >
              </p-multiSelect>
            </div>
          </div>
        </div>
      </div>
      <div style="flex-grow: 1">
        <div *ngIf="jobInfo" style="height: 100%">
          <map-control
            #directToSupplierMap
            appendTo="body"
            [tasks]="jobInfo.tasks"
            [suppliers]="directSuppliers"
            [readOnly]="true"
            [customStyle]="{ height: '100%' }"
            [radiusPoints]="locationPoins"
            (driverPlanClick)="driverPlanClick($event)"
          ></map-control>
        </div>
      </div>
    </div>

    <!-- RIGHT SIDE -->
    <div style="display: flex; flex-direction: column; height: 100%; width: 40%">
      <div class="supplier-control-block">
        <span class="potential-suppliers-header"
          >Potential Suppliers: ({{ directSuppliers?.length }})</span
        >
        <div>
          <div class="input-group">
            <div class="input-group-item searchable">
              <p-multiSelect
                name="supplierOptions"
                [options]="supplierOptions"
                [(ngModel)]="selectedAddSuppliers"
                defaultLabel="Select supplier(s)"
                (onClick)="onSupplierSelect()"
                (keyup.enter)="onSupplierSelect()"
                class="filter-dropdown input-group-filter w-100"
                [filter]="true"
                pTooltip="Select supplier(s) to add to the list"
              ></p-multiSelect>
            </div>
          </div>

          <div style="display: flex; flex-direction: row; grid-gap: 5px; margin-top: 7px">
            <div style="flex-grow: 1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-multiSelect
                    name="classification"
                    [options]="supplierClassifications"
                    [(ngModel)]="selectedClassifications"
                    defaultLabel="Classification"
                    class="filter-dropdown input-group-filter"
                    (onChange)="onClassificationFilterChange($event)"
                    pTooltip="Filter by selected classification(s)"
                  ></p-multiSelect>
                </div>
              </div>
            </div>
            <div style="flex-grow: 1">
              <div class="input-group">
                <div class="input-group-item">
                  <p-multiSelect
                    name="contract"
                    [options]="supplierContractTypes"
                    [(ngModel)]="selectedContractTypes"
                    defaultLabel="Contract Type"
                    class="filter-dropdown input-group-filter"
                    (onChange)="onContractTypeFilterChange($event)"
                    pTooltip="Filter by selected contract type(s)"
                  ></p-multiSelect>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="grid-item-jobs-filter">
          <div style="display: flex; grid-gap: 14px">
            <p-radioButton
              name="jobFilter"
              #dayOrder
              value="all"
              [(ngModel)]="jobFilterButtonVal"
              (ngModelChange)="onJobFilterChange($event)"
              label="All"
              inputId="1"
            ></p-radioButton>
            <p-radioButton
              name="jobFilter"
              #dayOrder
              value="onlyJobs"
              [(ngModel)]="jobFilterButtonVal"
              (ngModelChange)="onJobFilterChange($event)"
              label="Has Tasks"
              inputId="2"
              pTooltip="Show only suppliers with jobs in their plan"
            ></p-radioButton>
            <p-radioButton
              name="jobFilter"
              #dayOrder
              value="noJobs"
              [(ngModel)]="jobFilterButtonVal"
              (ngModelChange)="onJobFilterChange($event)"
              label="No Tasks"
              inputId="3"
              pTooltip="Show only suppliers with no jobs in their plan"
            ></p-radioButton>
          </div>
          <div>
            <p-checkbox
              id="excludeUnsuitable"
              name="excludeUnsuitable"
              [(ngModel)]="excludeUnsuitable"
              label="Exclude Unsuitable"
              (onChange)="onExcludeUnsuitableChanged()"
              binary="true"
              pTooltip="Exclude suppliers who do not have the appropriate tagging attributes"
            >
            </p-checkbox>
          </div>
        </div>
      </div>

      <div style="flex-grow: 1; overflow-y: scroll">
        <div style="height: 100%">
          <p-table [value]="directSuppliers" styleClass="no-header" scrollable="true">
            <ng-template pTemplate="body" let-item>
              <tr>
                <td>
                  <supplier-card
                    [data]="item"
                    (driverPlanClick)="driverPlanClick($event)"
                    [showAvailability]="true"
                  ></supplier-card>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="message-area-block">
        <div class="direct-and-notify">
          <label for="ta"
            ><strong
              >Direct & Notify
              <i
                class="fa fa-question-circle"
                tooltipStyleClass="xtooltip"
                pTooltip="Clicking ‘Send’ will move this job to suppliers’ ‘Directed To You’ tab and notify all available drivers via text message, except those on ‘Do Not Disturb’."
              ></i></strong
          ></label>
        </div>
        <div class="input-group">
          <textarea id="ta" [(ngModel)]="smsText" rows="2" class="message-text-area"></textarea>
        </div>
        <div class="message-options">
          <div style="flex-shrink: 1; display: flex">
            <p-inputSwitch
              id="push"
              (onChange)="onRadiusChange({ value: searchRadius })"
              [(ngModel)]="sendPushNotification"
              class="mr-1 mt-1"
            ></p-inputSwitch>
          </div>
          <div style="flex-grow: 1">
            <label for="push" style="margin-right: 5px">Push Notification</label>
            <i
              class="fa fa-info-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Activating this toggle will send a free push notification to a suppliers mobile phone."
            ></i>
          </div>

          <div style="flex-shrink: 1; display: flex">
            <p-inputSwitch
              id="sms"
              (onChange)="onRadiusChange({ value: searchRadius })"
              [(ngModel)]="sendJobAlert"
              class="mr-1 mt-1"
            ></p-inputSwitch>
          </div>
          <div style="flex-grow: 1">
            <label for="sms" style="margin-right: 5px">Job Alert SMS</label>
            <i
              class="fa fa-info-circle"
              tooltipStyleClass="xtooltip"
              pTooltip="Activating this toggle will send a text message notification to a supplier's mobile phone, incurring a cost."
            ></i>
          </div>
          <div style="flex-grow: 1; text-align: right">
            <button
              type="button"
              pButton
              icon="fa fa-paper-plane"
              class="green-btn"
              (click)="directToSupplierSave()"
              [disabled]="directSuppliers.length == 0"
              label="Send"
            ></button>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="searchingSuppliers"
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: gray;
        opacity: 0.3;
      "
    >
      <img
        src="assets/images/loader.gif"
        style="margin-left: 45%; margin-top: 20%"
        width="50"
        height="50"
        alt="load"
      />
    </div>
  </div>
</p-dialog>
